import { Typography, Grid, Checkbox, Select, Input, MenuItem, ListItemText, FormControl, Button, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, TableContainer, Box, Divider } from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../css/styles.css";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetShiftTimeConfigureAction } from "../../../../../store/Leave/ShiftConfigure/Action";
import { GetWeekDaysAction } from "../../../../../store/Ancillary/WeekDays/Action";
import { GetWeekdatesHelper } from "../../helper/TimeSheet/MyTimeSheetHelper";
import { AddAssignShiftTimeHelper, DeleteAssignShiftTimeHelper, GetAssignShiftTimeHelper, GetWeekHelper, UpdateAssignShiftTimeHelper } from "../../helper/Team/TeamHelper";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import footerlogoSrc from "../../image/Meepl_new_logo with text png.png";
import { ConvertTimeOnly } from "../../../Base/helper/baseFunctions";

const AssignShift = () => {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 200,
            },
        },
    };
    const dispatch = useDispatch();
    const date = new Date();
    const [input, setInput] = useState({
        week: "",
        month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    });
    const [multipleWeeks, setMultipleWeeks] = useState("")
    const [assignShiftData, setAssignShiftData] = useState([]);
    const [shiftConsolidatedData, setShiftConsolidatedData] = useState([]);
    const [consolidatedLoading, setConsolidatedLoading] = useState(false);
    const [shift, setShift] = useState("add");
    const [errors, setErrors] = useState({});
    const [disabledShift, setDisabledShift] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [weekDays, setWeekDays] = useState([]);
    const [employeesData, setEmployeesData] = useState({
        load: true,
        values: [],
    });
    const [shiftData, setShiftData] = useState({
        load: true,
        values: [],
    });
    const [weekData, setWeekData] = useState({
        load: true,
        values: [],
    });
    const dayMapping = {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday"
    };
    const { shift_time_options } = useSelector(state => state?.LeaveReducer?.ShiftTimeConfigureReducer);
    const { week_days_options } = useSelector((state) => state.AncillaryReducer.WeekDaysReducer);
    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
    const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");
    
    const { employees_options } = useSelector(
        (state) => state.EmployeeReducer.EmployeesReducer,
    );
    const handleEmployees = () => {
        if (!employees_options) return;

        const assignedIds = assignShiftData?.map(row => row.employee_id?.employee_id)?.filter(Boolean);

        const filteredEmployees = employees_options?.filter(emp => !assignedIds?.includes(emp.employee_id));

        setEmployeesData({ load: false, values: filteredEmployees});
    };
    const handleShift = () => {
        shift_time_options &&
            setShiftData({ load: false, values: shift_time_options });
    };
    const formatDataStructure = (data) => {
        return (data || [])?.map(employee => ({
            employee_id: { employee_id: employee.employee_fk, name: employee.employee_name },
            shift_roster_configuration_id: { shift_roster_configuration_id: employee.shift_configuration_id, shift_name: employee.shift_name },
            week_off_id: Array.isArray(employee.week_off_custom_json)
                ? employee.week_off_custom_json
                : employee.week_off_custom_json
                    ? JSON.parse(employee.week_off_custom_json)
                    : [],
            days: employee.day_shift_mapping_json.reduce((acc, day) => {
                acc[day.day_name] = {
                    shift_roster_configuration_id: day.shift_roster_configuration_id || "",
                    shift_name: day.shift_name || "",
                    in_time: day.in_time || "",
                    out_time: day.out_time || "",
                    pay: day.pay || "",
                    date: day.date || "",
                    alias: day.alias || ""
                };
                return acc;
            }, {}),
            shift_roster_id: employee.shift_roster_id
        }));
    }
    useEffect(() => {
       dispatch(GetEmployeesAction({ is_active: true }));
        dispatch(GetShiftTimeConfigureAction());
        dispatch(GetWeekDaysAction());
    }, [dispatch]);
    useEffect(() => {
        const [year, month] = input.month_year.split("-");
        if (input?.month_year) {
            GetWeekHelper({
                month_id: parseInt(month, 10) || null,
                year: parseInt(year, 10)
            }).then((res) => {
                setWeekData({ load: false, values: res?.data?.data });
            });
        }
        else {
            setWeekData({ load: false, values: [] });
        }
        if (input?.month_year && input?.week?.week_no_id) {
            setIsLoading(true);
            const [start_year, start_month, start_day] = input?.week?.week_start_date.split("-");
            const [end_year, end_month, end_day] = input?.week?.week_end_date.split("-");
            GetWeekdatesHelper({
                start_date_day: start_day,
                start_date_month: start_month,
                start_date_year: start_year,
                end_date_day: end_day,
                end_date_month: end_month,
                end_date_year: end_year,
            }).then((res) => {
                const newWeekDays = res?.data?.data?.[0]?.fn_map_days_to_dates || [];
                setWeekDays(newWeekDays);
                setAssignShiftData(prevData =>
                    prevData?.map(row => ({
                        ...row,
                        days: Object.fromEntries(
                            newWeekDays.map(day => [
                                day,
                                row.days[day] || { shift_roster_configuration_id: "", shift_name: "", in_time: "", out_time: "", pay: "", alias: "" }
                            ])
                        )
                    }))
                );
            });
            GetAssignShiftTimeHelper({
                month_id: parseInt(month, 10) || null,
                week_id: `{${input?.week?.week_no_id}}` || null,
                year: parseInt(year, 10)
            }).then((res) => {
                const responseData = res?.data?.data || [];
                const formattedData = formatDataStructure(responseData)
                setAssignShiftData(formattedData);
                setShift(responseData?.length > 0 ? "edit" : "add");
                setIsLoading(false);
            });
        }
    }, [input]);
    useEffect(() => {
        const allFieldsEmpty = assignShiftData?.some(
            (shift) =>
                shift?.tempId
        )
        setDisabledShift(allFieldsEmpty);
    }, [assignShiftData]);
    const handleInput = (event, value) => {
        const newInput = { ...input };
        if (event === "week") {
            newInput.week = value;
        }
        else if (event?.target?.name === "month_year") {
            newInput["month_year"] = event.target.value;
            newInput.week = "";
            setMultipleWeeks("");
            setShiftConsolidatedData([]);
        }
        else {
            newInput[event.target.name] = event.target.value;
        }
        setEmployeesData({load: true, values: []});
        setInput(newInput);
        setAssignShiftData([]);
        if (Object.values(errors).some((res) => res !== "")) {
            validate({ ...input, [event]: value || "" });
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
        }));
    };
    const handleRowChange = (id, field, value) => {
        setAssignShiftData((prev) =>
            prev.map((row, index) => {
                if (index === id) {
                    if (field === "employee_id") {
                        if (shift === "add") {
                            const defaultShift = shift_time_options?.find(shift => shift.is_default);
                            if (defaultShift) {
                                return {
                                    ...row,
                                    [field]: value,
                                    shift_roster_configuration_id: defaultShift,
                                    shift_name: defaultShift.shift_name,
                                    days: Object.fromEntries(
                                        Object.keys(row.days).map((day) => [
                                            day,
                                            {
                                                shift_roster_configuration_id: defaultShift.shift_roster_configuration_id || "",
                                                shift_name: defaultShift.shift_name || "",
                                                in_time: defaultShift.in_time || "",
                                                out_time: defaultShift.out_time || "",
                                                pay: defaultShift.pay || "",
                                                alias: defaultShift.alias || ""
                                            }
                                        ])
                                    )
                                };
                            }
                        }
                        return {
                            ...row,
                            [field]: value
                        };
                    }
                    if (field === "shift_roster_configuration_id") {
                        const selectedShift = shiftData?.values?.find(
                            shift => shift.shift_roster_configuration_id === value?.shift_roster_configuration_id
                        );
                        return {
                            ...row,
                            [field]: value,
                            shift_name: selectedShift?.shift_name || "",
                            days: Object.fromEntries(
                                Object.keys(row.days).map((day) => [
                                    day,
                                    {
                                        shift_roster_configuration_id: selectedShift?.shift_roster_configuration_id || "",
                                        shift_name: selectedShift?.shift_name || "",
                                        in_time: selectedShift?.in_time || "",
                                        out_time: selectedShift?.out_time || "",
                                        pay: selectedShift?.pay || "",
                                        alias: selectedShift?.alias || ""
                                    }
                                ])
                            )
                        };
                    }
                    if (field === "week_off_id") {
                        const currentSelections = Array.isArray(row.week_off_id) ? row.week_off_id : [];
                        const newSelection = Array.isArray(value) ? value : [];
                        const toggledItem = newSelection.find(item =>
                            !currentSelections.some(curr => curr.week_day_pk === item.week_day_pk)
                        ) || currentSelections.find(item =>
                            !newSelection.some(curr => curr.week_day_pk === item.week_day_pk)
                        );
                        let result;
                        if (toggledItem) {
                            if (currentSelections.some(item => item.week_day_pk === toggledItem.week_day_pk)) {
                                result = currentSelections.filter(item => item.week_day_pk !== toggledItem.week_day_pk);
                            }
                            else {
                                result = [...currentSelections, toggledItem];
                            }
                        } else {
                            result = newSelection;
                        }
                        const uniqueWeekOff = Array.from(
                            new Map(result.map(item => [item.week_day_pk, item])).values()
                        );
                        return {
                            ...row,
                            [field]: uniqueWeekOff
                        };
                    }
                    return { ...row, [field]: value };
                }
                return row;
            })
        );
    };
    const handleDayChange = (rowId, day, value) => {
        setAssignShiftData((prev) => prev.map((row, index) =>
            index === rowId ? { ...row, days: { ...row.days, [day]: value } } : row
        ));
    };
    const handleDelete = async (rowIndex) => {
        const row = assignShiftData[rowIndex];
        if (!row) return;

        try {
            const [year, month] = input.month_year.split("-");
            if (row.shift_roster_id) {
                await DeleteAssignShiftTimeHelper({
                    shift_roster_id: row.shift_roster_id,
                    month_id: parseInt(month, 10) || null,
                    week_id: input?.week?.week_no_id || null,
                    year: parseInt(year, 10),
                });
                fetchConsolidatedData(multipleWeeks);
            }
            setEmployeesData({load: true, values: []});
            setAssignShiftData(prev => prev.filter((_, index) => index !== rowIndex));
            const updatedData = assignShiftData.filter((_, index) => index !== rowIndex);
            if (updatedData.length === 0) {
                setShift("add");
            }
        } catch (error) {
            toast.error("Delete failed");
        }
    };
    const handleAdd = () => {
        if (validate(input)) {
            setAssignShiftData(prevData => [
                ...prevData,
                {
                    tempId: Date.now(),
                    employee_id: "",
                    shift_roster_configuration_id: "",
                    week_off_id: "",
                    days: Object.fromEntries(
                        weekDays.map(day => [
                            day,
                            { shift_roster_configuration_id: "", shift_name: "", in_time: "", out_time: "", pay: "", alias: "" }
                        ])
                    )
                }
            ]);
        }
    };
    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("week" in fieldValues) {
            temp.week =
                fieldValues.week === "" ? "Week is required" : "";
        }
        setErrors({
            ...temp,
        });

        return Object.values(temp).every((x) => x === "");
    };
    const handleSubmit = async (rowIndex) => {
        const row = assignShiftData[rowIndex];
        if (!row) return console.error("Row not found!");
        const weekDayMap = {
            "Sunday": "Sun", "Monday": "Mon", "Tuesday": "Tue",
            "Wednesday": "Wed", "Thursday": "Thu", "Friday": "Fri", "Saturday": "Sat"
        };
        const weekOffDays = Array.isArray(row.week_off_id) && row.week_off_id.length > 0
            ? row.week_off_id.map(wo => weekDayMap[wo.week_day_name])
            : [];
        const shiftRosterId = row.shift_roster_id || null;
        const parseDayToDbDate = (dayStr) => {
            if (!dayStr) return "";
            const monthNames = {
                jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
                jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12"
            };
            const parts = dayStr.split("-").map(p => p.trim());
            if (parts.length >= 3) {
                const d = parts[0].padStart(2, "0");
                const mKey = parts[1].toLowerCase().slice(0, 3);
                const m = monthNames[mKey] || "01";
                const yAndDay = parts[2].split(" ")[0].trim();
                if (yAndDay && d) {
                    return `${yAndDay}-${m}-${d}`;
                }
            }
            if (dayStr.includes("/")) {
                const slashParts = dayStr.split(" ")[0].split("/").map(p => p.trim());
                if (slashParts.length === 3) {
                    const d = slashParts[0].padStart(2, "0");
                    const m = slashParts[1].padStart(2, "0");
                    const y = slashParts[2];
                    return `${y}-${m}-${d}`;
                }
            }
            const parsed = new Date(dayStr.replace(/([A-Za-z]{3})$/, '').trim());
            if (!isNaN(parsed.getTime())) {
                const y = parsed.getFullYear();
                const m = String(parsed.getMonth() + 1).padStart(2, "0");
                const d = String(parsed.getDate()).padStart(2, "0");
                return `${y}-${m}-${d}`;
            }
            return "";
        };

        const dayShiftData = Object.keys(row.days).map(day => {
            const dayName = day.split(" ").pop();
            const isWeekOff = weekOffDays.includes(dayName);
            const formattedDate = parseDayToDbDate(day);
            return isWeekOff
                ? { day_name: day, shift_roster_configuration_id: "", shift_name: "", in_time: "", out_time: "", pay: "", alias: "", date: formattedDate }
                : {
                    day_name: day,
                    shift_roster_configuration_id: row.days[day]?.shift_roster_configuration_id || "",
                    shift_name: row.days[day]?.shift_name || "",
                    in_time: row.days[day]?.in_time || "",
                    out_time: row.days[day]?.out_time || "",
                    pay: row.days[day]?.pay || "",
                    alias: row.days[day]?.alias || "",
                    date: formattedDate
                };
        });
        const formattedRow = {
            shift_roster_id: shiftRosterId,
            employee_id: row.employee_id?.employee_id || null,
            shift_roster_configuration_id: row.shift_roster_configuration_id?.shift_roster_configuration_id || null,
            week_off_custom_json: weekOffDays.length > 0 ? JSON.stringify(
                row.week_off_id.map(wo => ({
                    week_day_pk: wo.week_day_pk,
                    week_day_name: wo.week_day_name
                }))
            ) : null,
            day_shift_mapping_json: JSON.stringify(dayShiftData)
        };
        if (!formattedRow.employee_id) {
            toast.error("Employee ID is required!");
            return;
        }
        const hasValidShift = dayShiftData.some(shift =>
            shift.day_name && (shift.shift_name || shift.in_time || shift.out_time)
        );
        if (!hasValidShift) {
            toast.error("At least one valid shift must be assigned!");
            return;
        }
        try {
            const [year, month] = input.month_year.split("-");
            let response;
            if (shiftRosterId) {
                response = await UpdateAssignShiftTimeHelper({
                    shift_roster_id: shiftRosterId,
                    month_id: parseInt(month, 10) || null,
                    week_id: input?.week?.week_no_id || null,
                    year: parseInt(year, 10),
                    employee_id: formattedRow.employee_id,
                    shift_configuration_id: formattedRow.shift_roster_configuration_id,
                    week_off_custom_json: formattedRow.week_off_custom_json,
                    day_shift_mapping_json: formattedRow.day_shift_mapping_json
                });
            } else {
                response = await AddAssignShiftTimeHelper({
                    month_id: parseInt(month, 10) || null,
                    week_id: input?.week?.week_no_id || null,
                    year: parseInt(year, 10),
                    employee_id: formattedRow.employee_id,
                    shift_configuration_id: formattedRow.shift_roster_configuration_id,
                    week_off_custom_json: formattedRow.week_off_custom_json,
                    day_shift_mapping_json: formattedRow.day_shift_mapping_json
                });
            }
            const responseData = response?.data?.data || [];
            fetchConsolidatedData(multipleWeeks);
            setShift("edit");
            setEmployeesData({load: true, values: []});
            const formattedData = formatDataStructure(responseData)
            if (shiftRosterId) {
                const filtTempData = assignShiftData?.filter(el => el?.tempId)
                setAssignShiftData([...formattedData, ...filtTempData]);
            }
            else {
                setAssignShiftData(formattedData);
            }
        } catch (error) {
            toast.error("Failed to save shift!");
        }
    };

    const handleFilter = async (event, value) => {
        if (event === "multiple_week") {
            const sortedValue = Array.isArray(value)
                ? [...value].sort((a, b) => new Date(a.week_start_date) - new Date(b.week_start_date))
                : value;
            setMultipleWeeks(sortedValue);
            await fetchConsolidatedData(sortedValue);
        }  
    };

    const handleDownloadPDF = () => {
        if (!shiftConsolidatedData?.allDates?.length || !shiftConsolidatedData?.employees?.length) {
            toast.error("No data available to export");
            return;
        }

        const doc = new jsPDF("l", "mm", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const DATE_CHUNK_SIZE = 14; // 2 weeks max per page

        // Dynamically calculate maximum rows that fit up to the page bottom
        const startY = 20;
        const bottomReserved = 28; // Reserved for Note legend and footer logo
        const headerHeight = 14;   // 2-tier header height
        const rowHeight = 7.2;     // Height per employee row
        const EMP_CHUNK_SIZE = Math.max(1, Math.floor((pageHeight - startY - bottomReserved - headerHeight) / rowHeight));

        const allDates = shiftConsolidatedData.allDates;
        const allEmployees = shiftConsolidatedData.employees;

        const dateChunks = [];
        for (let i = 0; i < allDates.length; i += DATE_CHUNK_SIZE) {
            dateChunks.push(allDates.slice(i, i + DATE_CHUNK_SIZE));
        }

        const empChunks = [];
        for (let i = 0; i < allEmployees.length; i += EMP_CHUNK_SIZE) {
            empChunks.push(allEmployees.slice(i, i + EMP_CHUNK_SIZE));
        }

        let isFirstPage = true;

        dateChunks.forEach((dateChunk) => {
            empChunks.forEach((empChunk) => {
                if (!isFirstPage) {
                    doc.addPage("a4", "l");
                }
                isFirstPage = false;

                doc.setFontSize(14);
                doc.setFont("helvetica", "bold");
                doc.setTextColor(33, 33, 33);
                doc.text("Consolidated Shift View", 14, 15);

                const header1 = ["Employee", ...dateChunk.map(day => extractDate(day))];
                const header2 = ["", ...dateChunk.map(day => day.split(" ").pop())];

                const body = empChunk.map(row => {
                    const rowData = [row.name];
                    dateChunk.forEach(day => {
                        const shiftCode = row.days[day] || "-";
                        rowData.push(shiftCode);
                    });
                    return rowData;
                });

                autoTable(doc, {
                    head: [header1, header2],
                    body: body,
                    startY: 20,
                    theme: "grid",
                    headStyles: {
                        fillColor: [139, 68, 255],
                        textColor: [255, 255, 255],
                        fontStyle: "bold",
                        halign: "center",
                        fontSize: 9,
                        cellPadding: 2
                    },
                    styles: {
                        halign: "center",
                        fontSize: 8.5,
                        cellPadding: 2,
                        textColor: [50, 50, 50]
                    },
                    columnStyles: {
                        0: {
                            halign: "left",
                            fontStyle: "bold",
                            fillColor: [245, 245, 245],
                            cellWidth: 42
                        }
                    },
                    didParseCell: function (data) {
                        if (data.section === "head" && data.row.index === 1) {
                            data.cell.styles.fillColor = [196, 163, 255];
                        }
                    }
                });

                // Compute unique shift codes present in this page's body only
                const usedShiftCodes = new Set();
                body.forEach(row => {
                    for (let c = 1; c < row.length; c++) {
                        const val = row[c];
                        if (val && val !== "-" && val !== "") {
                            usedShiftCodes.add(val.trim());
                        }
                    }
                });

                const noteItems = [];
                usedShiftCodes.forEach(code => {
                    if (code === "W O" || code === "WO") {
                        noteItems.push("W O - Week Off");
                        return;
                    }
                    const matchedShift = shift_time_options?.find(
                        s => (s.alias && s.alias.trim() === code) || (s.shift_name && s.shift_name.trim() === code)
                    );
                    if (matchedShift) {
                        let timingStr = "";
                        if (matchedShift.breakshift_flag) {
                            timingStr = `${ConvertTimeOnly(matchedShift.before_in_time)} - ${ConvertTimeOnly(matchedShift.before_out_time)}, ${ConvertTimeOnly(matchedShift.after_in_time)} - ${ConvertTimeOnly(matchedShift.after_out_time)}`;
                        } else if (matchedShift.in_time && matchedShift.out_time) {
                            timingStr = `${ConvertTimeOnly(matchedShift.in_time)} - ${ConvertTimeOnly(matchedShift.out_time)}`;
                        }
                        const label = matchedShift.alias
                            ? `${matchedShift.alias} - ${matchedShift.shift_name}${timingStr ? ` (${timingStr})` : ""}`
                            : `${matchedShift.shift_name}${timingStr ? ` (${timingStr})` : ""}`;
                        noteItems.push(label);
                    } else {
                        noteItems.push(code);
                    }
                });

                const finalY = doc.lastAutoTable?.finalY || 150;
                if (noteItems.length > 0) {
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(80, 80, 80);
                    doc.text("Note:", 14, finalY + 7);

                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(100, 100, 100);
                    const noteText = noteItems.join(",  ");
                    const splitNotes = doc.splitTextToSize(noteText, pageWidth - 35);
                    doc.text(splitNotes, 24, finalY + 7);
                }

                // Footer (Right corner: "powered by" + logo)
                try {
                    const imgWidth = 24;
                    const imgHeight = 8;
                    const text = "powered by";
                    const gap = 3;
                    const marginRight = 14;
                    const footerY = pageHeight - 12;

                    doc.setFontSize(8.5);
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(120, 120, 120);

                    const textWidth = doc.getTextWidth(text);
                    const totalWidth = textWidth + gap + imgWidth;
                    const startX = pageWidth - marginRight - totalWidth;
                    const centerY = footerY + imgHeight / 2;

                    doc.text(text, startX, centerY, { baseline: "middle" });
                    doc.addImage(footerlogoSrc, "PNG", startX + textWidth + gap, footerY, imgWidth, imgHeight);
                } catch (err) {
                    console.error("Error adding footer logo to PDF:", err);
                }
            });
        });

        doc.save("Consolidated_Shift_View.pdf");
    };
    const fetchConsolidatedData = async (weeks) => {
        if (!weeks || weeks.length === 0) {
            setShiftConsolidatedData([]);
            return;
        }
        setConsolidatedLoading(true);
        const [year, month] = input.month_year.split("-");

        const sortedWeeks = Array.isArray(weeks)
            ? [...weeks].sort((a, b) => new Date(a.week_start_date) - new Date(b.week_start_date))
            : weeks;

        let allData = [];
        let allDates = [];

        for (let week of sortedWeeks) {
            const [start_year, start_month, start_day] = week.week_start_date.split("-");
            const [end_year, end_month, end_day] = week.week_end_date.split("-");

            const weekDatesRes = await GetWeekdatesHelper({
                start_date_day: start_day,
                start_date_month: start_month,
                start_date_year: start_year,
                end_date_day: end_day,
                end_date_month: end_month,
                end_date_year: end_year,
            });

            const weekDates = weekDatesRes?.data?.data?.[0]?.fn_map_days_to_dates || [];
            allDates.push(...weekDates);

            const res = await GetAssignShiftTimeHelper({
                month_id: parseInt(month, 10),
                week_id: `{${week.week_no_id}}`,
                year: parseInt(year, 10)
            });

            const formatted = formatDataStructure(res?.data?.data || []);
            allData.push(...formatted);
        }

        const uniqueDates = Array.from(new Set(allDates));

        const merged = mergeEmployeeShifts(allData, uniqueDates);

        setShiftConsolidatedData({
            employees: merged,
            allDates: uniqueDates
        });
        setConsolidatedLoading(false);
    };


    return (
        <Box position={"relative"}>
            <>
            <BackdropMeepl open={isLoading} dark={false}/>
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ pt: 2, pb: 2 }}
                gap={0.5}
            >
                <Grid item>
                    <Typography variant="h6" sx={{ pl: 2 }}>
                        Assign Shift
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid
                        container
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid item>
                            <FormControl fullWidth>
                                <CommonDatePicker
                                    required={true}
                                    name="month_year"
                                    openTo="month"
                                    views={['year', 'month']}
                                    label="Month and Year"
                                    size="small"
                                    onKeyDown={(e) => e.preventDefault()}
                                    pickerFormat="MM/yyyy"
                                    DefaultDTvalue={input?.month_year}
                                    minDate={new Date()}
                                    maxDate={new Date(new Date().getFullYear(), 11, 31)}
                                    handleChange={(value) =>
                                        handleInput({
                                            target: {
                                                name: "month_year",
                                                value: value ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}` : "",
                                            },
                                        })
                                    }
                                />
                            </FormControl>
                        </Grid>

                        <Grid item width={300}>
                            <FormControl fullWidth>
                                <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                        +option.week_no_id ===
                                        +value.week_no_id
                                    }
                                    label="Week"
                                    value={input?.week}
                                    loading={() =>
                                        setWeekData({
                                            load: false,
                                            values: [],
                                        })
                                    }
                                    required
                                    fieldLabel="label"
                                    variant={"outlined"}
                                    name="week"
                                    size="small"
                                    onChangeEvent={handleInput}
                                    data={weekData}
                                    {...(errors.week && {
                                        error: true,
                                        helperText: errors.week,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item pr={1}>
                            <Tooltip
                                title={ExternalUserCoreHr ? "Action is disabled." : ""}
                                placement="left"
                            >
                            <span>
                                <Button
                                    disabled={disabledShift || ExternalUserCoreHr}
                                    onClick={handleAdd}
                                    className="mpl-primary-btn"
                                >
                                    + Assign Shift
                                </Button>
                            </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
                {assignShiftData?.length > 0 && (
                    <TableContainer sx={{
                        minHeight: "150px",
                        maxHeight: "40vh",
                        overflowY: "auto",
                        overflowX: "auto",
                        minWidth: "100%",
                        maxWidth: "100px",
                    }}>
                        <Table
                            sx={{
                                border: "1px solid #ddd",
                                width: "100%",
                            }}
                            size="small"
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            border: "1px solid #ddd",
                                            backgroundColor: "#8b44ff",
                                            color: "#fff",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            p: 1,
                                            width: "auto",
                                            minWidth: "200px",
                                        }}
                                    >
                                        Employee
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            border: "1px solid #ddd",
                                            backgroundColor: "#8b44ff",
                                            color: "#fff",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            p: 1,
                                            width: "auto",
                                            minWidth: "200px",
                                        }}
                                    >
                                        Bulk Shift Assign
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            border: "1px solid #ddd",
                                            backgroundColor: "#8b44ff",
                                            color: "#fff",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            p: 1,
                                            width: "auto",
                                            minWidth: "200px",
                                        }}
                                    >
                                        Bulk Week Off Assign
                                    </TableCell>
                                    {Object.keys(assignShiftData[0]?.days || {})?.map((day, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                fontWeight: "bold",
                                                border: "1px solid #ddd",
                                                backgroundColor: "#8b44ff",
                                                color: "#fff",
                                                textAlign: "center",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                p: 1,
                                                width: "auto",
                                                minWidth: "200px",
                                            }}
                                        >
                                            {day}
                                        </TableCell>
                                    ))}
                                    {!ExternalUserCoreHr && (
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            border: "1px solid #ddd",
                                            backgroundColor: "#8b44ff",
                                            color: "#fff",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            width: "5%",
                                        }}
                                    >
                                        Action
                                    </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {assignShiftData?.map((row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        <TableCell sx={{ border: "1px solid #ddd", p: 1, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden" }}>
                                            <SelectableSearch
                                                fullWidth
                                                variantType="standard"
                                                size="small"
                                                loading={() => handleEmployees()}
                                                value={row.employee_id}
                                                fieldLabel="name"
                                                name="employee_id"
                                                onChangeEvent={(e, v) => handleRowChange(rowIndex, "employee_id", v)}
                                                data={employeesData}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #ddd", p: 1, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden" }}>
                                            <SelectableSearch
                                                fullWidth
                                                variantType="standard"
                                                loading={() => handleShift()}
                                                size="small"
                                                value={row.shift_roster_configuration_id}
                                                fieldLabel="shift_name"
                                                name="shift_roster_configuration_id"
                                                onChangeEvent={(e, v) => handleRowChange(rowIndex, "shift_roster_configuration_id", v)}
                                                data={shiftData}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #ddd", p: 1, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden" }}>
                                            <FormControl sx={{ width: 200 }} size="small">
                                                <Select
                                                    variant="standard"
                                                    labelId={`weekoff-label-${rowIndex}`}
                                                    multiple
                                                    value={Array.isArray(row.week_off_id) ? row.week_off_id : []}
                                                    onChange={(e) => handleRowChange(rowIndex, "week_off_id", e.target.value)}
                                                    input={<Input />}
                                                    renderValue={(selected) => selected.map((x) => x.week_day_name).join(', ')}
                                                    MenuProps={MenuProps}
                                                    isOptionEqualToValue={(option, value) => option.week_day_pk === value.week_day_pk}
                                                >
                                                    {week_days_options?.map((option) => {
                                                        const isSelected = Array.isArray(row.week_off_id) &&
                                                            row.week_off_id.some(item => item.week_day_pk === option.week_day_pk);
                                                        const handleToggle = (event) => {
                                                            event.stopPropagation();
                                                            const currentSelections = Array.isArray(row.week_off_id) ? [...row.week_off_id] : [];
                                                            let newSelections;
                                                            if (isSelected) {
                                                                newSelections = currentSelections.filter(
                                                                    item => item.week_day_pk !== option.week_day_pk
                                                                );
                                                            } else {
                                                                newSelections = [...currentSelections, option];
                                                            }
                                                            handleRowChange(rowIndex, "week_off_id", newSelections);
                                                        };

                                                        return (
                                                            <MenuItem key={option.week_day_pk} value={option}>
                                                                <Checkbox
                                                                    checked={isSelected}
                                                                    onClick={handleToggle}
                                                                />
                                                                <ListItemText primary={option.week_day_name} />
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>

                                        </TableCell>
                                        {Object.keys(row.days).map((day, index) => {
                                            const dayName = day.split(" ").pop();
                                            const fullDayName = dayMapping[dayName] || dayName;
                                            const weekOffArray = Array.isArray(row.week_off_id) ? row.week_off_id : [];
                                            const isWeekOff = weekOffArray.some((wo) => wo.week_day_name === fullDayName);
                                            return (
                                                <TableCell key={index} sx={{ border: "1px solid #ddd", p: 1, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                    {isWeekOff ? (
                                                        <Typography sx={{ color: "red", fontWeight: "bold", textAlign: "center" }}>WO</Typography>
                                                    ) : (
                                                        <SelectableSearch
                                                            fullWidth
                                                            loading={() => handleShift()}
                                                            variantType="standard"
                                                            size="small"
                                                            value={row.days[day]}
                                                            fieldLabel="shift_name"
                                                            onChangeEvent={(e, v) => handleDayChange(rowIndex, day, v)}
                                                            data={shiftData}
                                                        />
                                                    )}
                                                </TableCell>
                                            );
                                        })}
                                        {!ExternalUserCoreHr && (
                                        <TableCell sx={{ borderTop: "1px solid #ddd", p: 1.5, textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            <Tooltip title={row.shift_roster_id ? "Update" : "Add"} arrow>
                                                <CheckCircleOutlineIcon
                                                    sx={{
                                                        cursor: "pointer",
                                                        color: "green",
                                                        fontSize: "1.2rem",
                                                    }}
                                                    onClick={() => handleSubmit(rowIndex)}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Delete" arrow>

                                                {row.shift_roster_id ? (
                                                    <DeleteIcon
                                                        sx={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "1.2rem",
                                                        }}
                                                        onClick={() => handleDelete(rowIndex)}
                                                    />
                                                ) : (
                                                    <CloseIcon
                                                        sx={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "1.2rem",
                                                        }}
                                                        onClick={() => handleDelete(rowIndex)}
                                                    />
                                                )}

                                            </Tooltip>
                                        </TableCell>
                                        )}
                                    </TableRow>
                                ))}
                                {!ExternalUserCoreHr && (
                                <TableRow>
                                    <TableCell colSpan={Object.keys(assignShiftData[0]?.days || {})?.length + 3} sx={{ textAlign: "left", border: "1px solid #ddd", p: 1 }}>
                                        <Typography
                                            sx={{
                                                color: disabledShift ? "#ccc" : "#8b44ff",
                                                fontWeight: "bold",
                                                cursor: disabledShift ? "default" : "pointer",
                                                "&:hover": disabledShift ? {} : { textDecoration: "underline" },
                                                pointerEvents: disabledShift ? "none" : "auto",
                                            }}
                                            onClick={disabledShift ? undefined : handleAdd}
                                        >
                                            + Add Row...
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </>
            <Divider sx={{ my: 2, borderBottomWidth: 2 }} />

            <Grid container sx={{alignItems: "center", borderRadius: 1, position: "relative" }}>
                <BackdropMeepl open={consolidatedLoading} dark={false}/>
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom component="div" sx={{ p: 2 }}>
                        Consolidated View
                    </Typography>
                </Grid>
                <Grid item container xs={12} sm={8} justifyContent="flex-end" alignItems="center" spacing={2}>
                    <Grid item>
                         {shiftConsolidatedData?.employees?.length > 0 && (
                            <Tooltip title="Download as PDF">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={handleDownloadPDF}
                                    sx={{ minWidth: "auto"}}
                                >
                                    <PictureAsPdfIcon />
                                </Button>
                            </Tooltip>
                        )}
                    </Grid>
                    <Grid item minWidth={300}>
                        <FormControl fullWidth>
                            <SelectableSearch
                                isOptionEqualToValue={(option, value) =>
                                    +option.week_no_id ===
                                    +value.week_no_id
                                }
                                label="Select Multiple Weeks"
                                value={multipleWeeks}
                                loading={() =>
                                    setWeekData({
                                        load: false,
                                        values: [],
                                    })
                                }
                                required
                                fieldLabel="label"
                                variant={"outlined"}
                                name="multiple_week"
                                size="small"
                                limitTags={2}
                                multiple={true}
                                onChangeEvent={handleFilter}
                                data={weekData}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                 {/* Consolidated View */}
                {shiftConsolidatedData?.allDates?.length > 0 && (
                    <TableContainer sx={{ mt: 2, mb: 3, maxHeight: "50vh", overflow: "auto" }}>
                        <Table
                            sx={{
                                border: "1px solid #ddd",
                                width: "100%",
                            }}
                            size="small"
                            stickyHeader
                        >
                            <TableHead>
                                {/* HEADER: DATE NUMBERS */}
                                <TableRow>
                                    <TableCell sx={{
                                        fontWeight: "bold",
                                        border: "1px solid #ddd",
                                        backgroundColor: "#8b44ff",
                                        color: "#fff",
                                        textAlign: "center",
                                        minWidth: "150px",
                                        position: "sticky",
                                        left: 0,
                                        top: 0,
                                        zIndex: 5,
                                    }}>
                                        Employee
                                    </TableCell>

                                    {shiftConsolidatedData?.allDates?.map((day, i) => (
                                        <TableCell key={i} sx={{
                                            fontWeight: "bold",
                                            border: "1px solid #ddd",
                                            backgroundColor: "#8b44ff",
                                            color: "#fff",
                                            textAlign: "center",
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 4,
                                        }}>
                                            {extractDate(day)}
                                        </TableCell>
                                    ))}
                                </TableRow>

                                {/* HEADER: DAY NAMES */}
                                <TableRow>
                                    <TableCell sx={subHeaderStyle}></TableCell>

                                    {shiftConsolidatedData?.allDates?.map((day, i) => (
                                        <TableCell key={i} sx={subHeaderStyle}>
                                            {day.split(" ").pop()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {shiftConsolidatedData?.employees?.length > 0 ? (shiftConsolidatedData?.employees?.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell sx={employeeStyle}>
                                            {row.name}
                                        </TableCell>

                                        {shiftConsolidatedData?.allDates?.map((day, j) => {
                                            const shiftCode = row.days[day] || "-";
                                            return (
                                                <TableCell key={j} sx={{textAlign: "center"}}>
                                                    {shiftCode}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={(shiftConsolidatedData?.allDates?.length || 0) + 1}
                                            sx={{
                                                textAlign: "center",
                                                py: 3,
                                                fontWeight: "bold",
                                                color: "#888",
                                            }}
                                        >
                                            No Records Found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>
        </Box>

    )
}

const mergeEmployeeShifts = (data, allDates) => {
    const map = {};

    data?.forEach(emp => {
        const empId = emp.employee_id.employee_id;

        if (!map[empId]) {
            map[empId] = {
                name: emp.employee_id.name,
                days: {}
            };
        }

        Object.entries(emp.days).forEach(([day, value]) => {
            map[empId].days[day] = value?.alias || "W O";
        });
    });

    // Fill missing dates
    Object.values(map).forEach(emp => {
        allDates.forEach(day => {
            if (!emp.days[day]) {
                emp.days[day] = "-";
            }
        });
    });

    return Object.values(map);
};

const subHeaderStyle = {
    background: "#c4a3ff",
    textAlign: "center"
};

const employeeStyle = {
    fontWeight: "bold",
    background: "#f5f5f5"
};


const extractDate = (dayName) => {
    if (!dayName) return "";

    const parts = dayName.split(" - ");
    if (parts.length < 2) return "";

    return `${parts[0]} ${parts[1]}`;
};


export default AssignShift;